<template>
  <div id="app-login">

    <div>

      <div class="panel-login" :class="errorClass">

        <div class="wrapper">

          <div class="logo">
            <img src="../assets/logo-weebox.png">
          </div>

          <div class="notice error" v-bind:class="notice">{{ message }}</div>

          <div class="existing-profile" v-if="profileExists">
            <div class="existing-profile-container">
              <figure>
                <i class="icon icon-icon_users"></i>
              </figure>
              <span class="username">{{ credentials.email }}</span>
              <a class="switch" href="#" @click="switchUser">Autre utilisateur ?</a>
            </div>
          </div>

          <div data-id="connexion-form" v-if="ask_for_two_factor == false">
            <div class="form-field" v-if="!profileExists">
              <div class="form-label">
                <label>Utilisateur</label>
              </div>
              <div class="form-input">
                <div class="form-input-wrapper">
                  <input type="text" name="username" value="" v-model="credentials.email" v-on:keyup="onEnter" placeholder="Utilisateur"/>
                </div>
              </div>
            </div>

            <div class="form-field">
              <div class="form-label">
                <label>Mot de passe</label>
              </div>
              <div class="form-input">
                <div class="form-input-wrapper">
                  <input type="password" name="password" value="" v-model="credentials.password" v-on:keyup="onEnter" placeholder="Mot de passe"/>
                </div>
              </div>
            </div>
          </div>

          <div data-id="two-factor-auth" v-if="ask_for_two_factor == true">
            <p>Veuillez saisir le code à 6 chiffres qui vous a été envoyé à {{ sent_to }}.</p>
            <br>
            <div class="form-field form-token">
              <div class="form-label">
                <label>Code</label>
              </div>
              <div class="form-input">
                <div class="form-input-wrapper">

                    <input type="text" value="" v-model="token_1" v-on:keyup="onEnterCode" @paste="onPaste" maxlength="1"/>
                    <input type="text" value="" v-model="token_2" v-on:keyup="onEnterCode" @paste="onPaste" maxlength="1" />
                    <input type="text" value="" v-model="token_3" v-on:keyup="onEnterCode" @paste="onPaste" maxlength="1" />
                    <input type="text" value="" v-model="token_4" v-on:keyup="onEnterCode" @paste="onPaste" maxlength="1" />
                    <input type="text" value="" v-model="token_5" v-on:keyup="onEnterCode" @paste="onPaste" maxlength="1" />
                    <input type="text" value="" v-model="token_6" v-on:keyup="onEnterCode" @paste="onPaste" maxlength="1" />

                </div>
              </div>
            </div>
            <a class="switch" href="#" @click="resendCode">Renvoyer le code</a>
          </div>

          <footer>

            <button type="submit" class="bt bt-primary" @click="submit()" :class="{'is-loading': loading}">
              <div class="component-loader"><i></i></div>
              <span>Login</span>
            </button>

            <span class="more-info">Qu'est-ce que Weebox ? <a href="https://weebox.ch" target="_blank">Plus d'infos</a></span>
          </footer>

        </div>

      </div>


    </div>

  </div>
</template>

<script>
    export default {
        name: 'login',
        data() {
            return {
                loading: false,
                errorClass: "",
                notice: "hidden",
                message: "erreur",
                credentials: {
                    email: '',
                    password: '',
                    token: null
                },
                error: '',
                profileExists: false,
                ask_for_two_factor: false,
                sent_to: null,
                token_1: "",
                token_2: "",
                token_3: "",
                token_4: "",
                token_5: "",
                token_6: ""
            }
        },
        mounted: function(){

          this.$store.dispatch("logout").then(() => {
              // LOG OUT
          })

          this.credentials.email = localStorage.getItem('weebox.login.username') || null;

          if( this.credentials.email )
          {
            this.profileExists = true;
          }

        },
        methods: {
          onPaste: function(e) {
            let code = e.clipboardData.getData('text');
            this.token_1 = code.charAt(0);
            this.token_2 = code.charAt(1);
            this.token_3 = code.charAt(2);
            this.token_4 = code.charAt(3);
            this.token_5 = code.charAt(4);
            this.token_6 = code.charAt(5);
            return false;
          },
          updateToken: function()
          {
            this.credentials.token = [this.token_1,this.token_2,this.token_3,this.token_4,this.token_5,this.token_6].join("")
          },
          resendCode: function(){
            this.ask_for_two_factor = false;
            this.token_1 = "";
            this.token_2 = "";
            this.token_3 = "";
            this.token_4 = "";
            this.token_5 = "";
            this.token_6 = "";
            this.credentials.token = null;
            return false;
          },
          switchUser: function(){
            localStorage.removeItem('weebox.login.username');
            this.ask_for_two_factor = false;
            this.credentials.email = null;
            this.credentials.token = null;
            this.profileExists = false;
            return false;
          },
            onEnter: function(e) {
                if (e.keyCode === 13) {
                    this.submit()
                }
            },
            onEnterCode: function(e) {
              e.preventDefault();
              e.stopPropagation();
              console.log(e.keyCode, e.target.value)
              const regex = /[0-9]/g;
              const found = e.target.value.match(regex);
              if(found){
                const next = e.target.nextElementSibling
                if(next === null) return
                if( e.keyCode !== 9 )
                {
                  e.target.nextElementSibling.focus()
                }
                return false;
              }else if (e.keyCode === 13) {
                this.submit()
              }else{
                e.target.value = ""
                return false;
              }
            },
            submit() {
              this.updateToken();
              this.errorClass = "";
              this.loading = true;
              var credentials = {
                  email: this.credentials.email,
                  password: this.credentials.password,
                  token: this.credentials.token
              }
              this.$store.dispatch("login", credentials).then(() => {
                this.loading = false;
                if( this.$store.state.scope == null ){
                    this.$router.push("/switch-scope")
                }else{
                    this.$router.push("/dashboard")
                }

              }).catch(e => {
                this.loading = false;
                if( e.data && e.data.ask_for_two_factor )
                {
                  this.ask_for_two_factor = true;
                  this.sent_to = e.data[e.data.sent_to ];
                }else{
                  this.errorClass = "has-error";
                }
              });
            }
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Login.vue